var exports = {
  "sy": "xaee3c4fa--c22aeb--subscribe-list",
  "TT": "xaee3c4fa--c22aeb--subscribe-list__header",
  "iA": "xaee3c4fa--c22aeb--subscribe-list__header_text-dekstop",
  "_n": "xaee3c4fa--c22aeb--subscribe-list__header_text-mobile",
  "FF": "xaee3c4fa--c22aeb--subscribe-list__header_arrow-icon",
  "hS": "xaee3c4fa--c22aeb--subscribe-list__header_mail-icon",
  "WD": "xaee3c4fa--c22aeb--subscribe-list__header_arrow-icon-open-content",
  "X3": "xaee3c4fa--c22aeb--subscribe-list__content",
  "Cf": "xaee3c4fa--c22aeb--subscribe-list__content_email",
  "W1": "xaee3c4fa--c22aeb--subscribe-list__content_button",
  "HE": "xaee3c4fa--c22aeb--subscribe-list__success",
  "sI": "xaee3c4fa--c22aeb--subscribe-list__error",
  "hq": "xaee3c4fa--c22aeb--subscribe-list__success_header",
  "Qm": "xaee3c4fa--c22aeb--subscribe-list__error_header",
  "rA": "xaee3c4fa--c22aeb--subscribe-list__success_text",
  "Az": "xaee3c4fa--c22aeb--subscribe-list__success_email",
  "R1": "xaee3c4fa--c22aeb--subscribe-list__wrap-regions_dropdown-wrap",
  "KX": "xaee3c4fa--c22aeb--subscribe-list__wrap-categories-wrap",
  "X6": "xaee3c4fa--c22aeb--subscribe-list__wrap-categories-wrap_checkbox-container-wrap",
  "he": "xaee3c4fa--c22aeb--subscribe-list__error-question",
  "lE": "xaee3c4fa--c22aeb--tooltip-email",
  "qY": "xaee3c4fa--c22aeb--license",
  "nf": "xaee3c4fa--c22aeb--link",
  "do": "xaee3c4fa--c22aeb--subscribe-list__header-open-content-mobile",
};

module.exports = exports;
